import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: 'md',
    },
    lang: {
        locales: { pt },
        current: 'pt'
    },
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#0067A5',
                secondary: '#ff9800'
            }
        }
    }
})
